<div class="c-randomprizeReward">
  <div
    class="c-randomprizeReward__background"
    theming
    themingGroup="randomprize"
    themingAsset="start-background"
    [themingOverride]="randomprizeRewardModalData?.properties?.assets">
    <div class="c-randomprizeReward__info">
      <div
        class="c-randomprizeReward__icon"
        theming
        themingGroup="randomprize"
        themingAsset="logo"
        [themingOverride]="randomprizeRewardModalData?.properties?.assets"></div>

      <div class="c-randomprizeReward__text">
        <span class="text title">{{ 'home.live-ops.randomprize.modal-reward.title' | translate | uppercase }}</span>
        <span class="text subtitle">{{ 'home.live-ops.randomprize.modal-reward.subtitle' | translate }}</span>

        <div
          class="c-randomprizeReward__container"
          data-testid="random-prize-reward-container">
          <div
            class="c-randomprizeReward__rewardBox"
            theming
            themingGroup="randomprize"
            themingAsset="reward-box"
            [themingOverride]="randomprizeRewardModalData?.properties?.assets">
            <slotcom-display [classes]="['c-display--magicbag', 'c-display--magicbag--reward']">
              <div
                displayIcon
                displayIconPos="left"
                class="c-display--coin"></div>
              <span [ngStyle]="{ 'font-size': setFontSize() }">{{
                randomprizeRewardModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate)
              }}</span>
            </slotcom-display>
          </div>
        </div>

        <slotcom-button
          class="c-button--pink"
          data-testid="random-prize-reward-button"
          (safeClick)="closeModal()"
          audioType="reward">
          {{
            randomprizeRewardModalData.properties.buttonText[lang()]
              ? randomprizeRewardModalData.properties.buttonText[lang()]
              : ('home.buttons.collect' | translate | uppercase)
          }}
        </slotcom-button>
      </div>
    </div>
  </div>
</div>
